import { Button } from "antd";
import { useContext } from "react";
import { useHistory, useParams } from "react-router";
import { ProjectContext } from "context/ProjectProvider";

/**
 * Empty-state copy when Schedules in OPC cannot load source schedules because
 * OPC is missing at project and/or subscription level — mirrors the Submittals
 * integration empty-state pattern (Click here + destination).
 */
export default function SchedulesInOpcEmptyMessage(props: {
  hasSubscriptionOpc: boolean;
}) {
  const { hasSubscriptionOpc } = props;
  const history = useHistory();
  const { projectId } = useParams<{ projectId: string }>();
  const { isProjectArchived } = useContext(ProjectContext);

  if (hasSubscriptionOpc) {
    return (
      <div
        className="absolute top-[45%] z-50 left-0 right-0 flex items-center justify-center text-sm space-x-1 px-4"
        data-testid="schedules-in-opc-empty-project"
      >
        <Button
          size="small"
          type="text"
          className="font-medium workflow-document-upload"
          disabled={!!isProjectArchived}
          onClick={() => {
            history.push(`/project/${projectId}/settings/integrations`);
          }}
          data-testid="schedules-in-opc-go-to-project-settings"
        >
          Click here
        </Button>
        <span>to configure OPC integration in Project Settings.</span>
      </div>
    );
  }

  return (
    <div
      className="absolute top-[45%] z-50 left-0 right-0 flex items-center justify-center text-sm space-x-1 px-4"
      data-testid="schedules-in-opc-empty-subscription"
    >
      <Button
        size="small"
        type="text"
        className="font-medium workflow-document-upload"
        disabled={!!isProjectArchived}
        onClick={() => {
          history.push("/settings/integrations");
        }}
        data-testid="schedules-in-opc-go-to-subscription-settings"
      >
        Click here
      </Button>
      <span>to configure OPC integration in Subscription Settings.</span>
    </div>
  );
}
